import { DateTime } from 'luxon';
import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';

const MILLISECONDS_IN_DAY = 1000 * 60 * 60 * 24;
const MILLISECONDS_TIMEZONE_OFFSET = new Date().getTimezoneOffset() * 60 * 1000;

const DayBreaker = ({
  time,
  previousTime,
}: {
  time: number;
  previousTime: number;
}) => {
  const [isSameDay, setIsSameDay] = useState(false);

  useEffect(() => {
    setIsSameDay(getIsSameDay(time, previousTime));
  }, [time, previousTime]);

  const getIsSameDay = (date1: number, date2: number) => {
    if (!date1 || !date2) {
      return false;
    }
    const [day1Day, day2Day] = [date1, date2].map(date =>
      Math.floor((date - MILLISECONDS_TIMEZONE_OFFSET) / MILLISECONDS_IN_DAY)
    );
    return day1Day === day2Day;
  };

  const timeFormat = useMemo(() => {
    const date = DateTime.fromMillis(time).startOf('day');
    const today = DateTime.now().startOf('day');

    if (date.equals(today)) {
      return 'Today';
    } else if (date.equals(today.minus({ days: 1 }))) {
      return 'Yesterday';
    } else if (date.equals(today.plus({ days: 1 }))) {
      return 'Tomorrow';
    }
    return date.toFormat('EEEE, LLLL d, yyyy');
  }, [time]);

  if (isSameDay) {
    return null;
  } else {
    return (
      <FeedListingHeaderStyled>
        <span>{timeFormat}</span>
      </FeedListingHeaderStyled>
    );
  }
};

const FeedListingHeaderStyled = styled.div`
  width: 100%;
  margin: 16px 0;
  text-align: center;
  font-size: 10px;
  position: relative;
  height: 12px;

  &:after {
    content: '';
    width: 100%;
    border-bottom: solid 1px #e1e5e5;
    position: absolute;
    left: 0;
    top: 50%;
    display: none;
  }

  span {
    background-color: #fff;
    width: auto;
    display: inline-block;
    padding: 0 5px 0 5px;
    color: #0a2127;
    position: absolute;
    font-size: 12px;
    font-weight: 600;
    margin: 0;
    left: 15px;
    top: 0;
  }
`;

export default DayBreaker;
